var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.583 20.196c.507 0 .917-.41.917-.917v-4.612h2.75c.506 0 .917-.41.917-.917v-11a.917.917 0 00-.917-.917H2.75a.917.917 0 00-.917.917v11c0 .506.41.917.917.917h7.843l4.283 5.195a.917.917 0 00.707.334zM3.667 3.666h14.666v9.167h-3.666v3.893l-3.21-3.893h-7.79V3.667z"
  })));
};

export default SvgChat;